import React, { useState } from 'react';
import { Box } from '@mui/material';
import SnapshotsList from '../snapshots-list';
import SnapshotAddUpdate from '../snapshot-add-update';
import { EditMode } from '../../../../data/enums';

export default function SnapshotsView() {

  const [editMode, setEditMode] = useState<EditMode>(EditMode.View);

  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>

      { (editMode === EditMode.View) && 
        <SnapshotsList mode={editMode} setEditMode={setEditMode}/>
      }

      { ((editMode === EditMode.Add || editMode === EditMode.Edit)) && 
        <SnapshotAddUpdate mode={editMode} setEditMode={setEditMode}/>
      }

    </Box>
  );
}

